import React from 'react'

export default function DocTitle({ title, onChange }) {
  React.useEffect(() => {
    document.title = title
    onChange()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}
